import BaseLasStrategy from './BaseLasStrategy';
import { ColorScheme } from './constants';
import lasRunner from './LasRunnerUtil';

class RepaymentStrategy extends BaseLasStrategy {}

type MakeRepaymentArgs = {
  interactionToken?: string;
  /**
   * Optional AbortSignal to cancel an in-flight repayment.
   *
   * On abort the SDK confirms the final state with the backend (the same flow
   * as an in-app cancel). In the typical cancellation case this REJECTS with a
   * `ScLoanError` whose `.data` holds the interaction status, so handle it in
   * `.catch`. It resolves only if the backend reports the repayment actually
   * completed.
   */
  signal?: AbortSignal;
  /** `dark` | `light` | `system`, forwarded verbatim as the `theme` query param */
  colorScheme?: ColorScheme;
};
async function makeRepayment({
  interactionToken,
  signal,
  colorScheme,
}: MakeRepaymentArgs = {}) {
  const intentStrategy = new RepaymentStrategy(interactionToken, {
    signal,
    colorScheme,
  });
  return lasRunner(intentStrategy);
}

export default makeRepayment;
